export default __webpack_public_path__ + "static/media/pulse-positive.34943fd0.svg";